import React from "react";
import env from "../../env";

function PreloadImage(props) {
    return <img src={props.src} aria-hidden className="preload" alt="Précarregamento de imagem." tabIndex={-1} />;
}

function PreloadFont(props) {
    return <p aria-hidden tabIndex={-1} className="preload" style={{fontFamily: props.name}}>Précarregamento de fonte.</p>;
}

function Preloader() {
    return (
        <div className="preload" aria-hidden tabIndex={-1}>
            <PreloadImage src={env.images.backgroundFeaturesDark} />
            <PreloadImage src={env.images.earthLights} />
            <PreloadImage src={env.images.city} />
            <PreloadImage src={env.images.contractor} />
            <PreloadImage src={env.images.news.aracaju_1} />
            <PreloadImage src={env.images.news.colombo_1} />
            <PreloadImage src={env.images.news.mogiDasCruzes_1} />
            <PreloadImage src={env.images.news.mogiDasCruzes_2} />
            <PreloadImage src={env.images.news.uniaoDaVitoria_1} />
            <PreloadImage src={env.images.news.paranagua_1} />
            <PreloadImage src={env.images.attendant} />
            <PreloadImage src={env.images.dashboard} />
            <PreloadImage src={env.images.facebookBot.step_1} />
            <PreloadImage src={env.images.facebookBot.step_2} />
            <PreloadImage src={env.images.facebookBot.step_3} />
            <PreloadImage src={env.images.telegramBot.step_1} />
            <PreloadImage src={env.images.telegramBot.step_2} />
            <PreloadImage src={env.images.telegramBot.step_3} />
            <PreloadImage src={env.images.telegramBot.step_4} />
            <PreloadImage src={env.images.telegramBot.chatExample} />
            <PreloadImage src={env.images.androidApp_1} />
            <PreloadImage src={env.images.androidApp_2} />
            <PreloadImage src={env.images.androidApp_3} />
            <PreloadImage src={env.images.selfServiceWebsite} />
            <PreloadImage src={env.images.attendant} />
            <PreloadFont name="Dredwerk" />
        </div>
    );
}

Preloader.PreloadImage = PreloadImage;
Preloader.PreloadFont = PreloadFont;

export default Preloader;
